export default "skymp5-front/434474aac1ca25361cc7f9fadc87043a.svg";